import { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";

import logo from "../../public/images/logo/elms-logo-black2.png";
import logo1 from "../../public/images/logo/elms-logo-black2.png";

import CopyRight from "./CopyRight";

import FooterData from "../../data/footer.json";
import SingleFooter from "./FooterProps/SingleFooter";
import { useAppContext } from "@/context/Context";


const FooterOne = ({ bgColor }) => {
  const { isLightTheme, toggleTheme } = useAppContext();
  
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ type: "", text: "" });
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    
    setMessage({ type: "", text: "" });

    if (!email.trim()) {
      setMessage({ type: "error", text: "Please enter your email address" });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage({ type: "error", text: "Please enter a valid email address" });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email.trim(),
          source: "footer-newsletter"
        }),
      });

      const data = await response.json();

      if (data.ok) {
        setMessage({ 
          type: "success", 
          text: data.message || "Successfully subscribed to our newsletter!" 
        });
        setEmail("");
      } else {
        setMessage({ 
          type: "error", 
          text: data.message || "Failed to subscribe. Please try again." 
        });
      }
    } catch (error) {
      console.error("Error subscribing:", error);
      setMessage({ 
        type: "error", 
        text: "Network error. Please check your connection and try again." 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <footer
        className={`rbt-footer footer-style-1 ${
          bgColor ? bgColor : "bg-color-white"
        } overflow-hidden`}
      >
        <div className="footer-top">
          <div className="container">
            {FooterData &&
              FooterData.footerTwo.map((footer, index) => (
                <div className="row g-5" key={index}>
                  <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                    <div className="footer-widget">
                      <div className="logo">
                        <Link href="/">
                        {isLightTheme ? <Image
                            src={logo}
                            width={152}
                            height={50}
                            alt="Edu-cause"
                          /> : <Image
                            src={logo1}
                            width={152}
                            height={50}
                            alt="Edu-cause"
                          />}
                        </Link>
                      </div>

                      <p className="description mt--20">{footer.description}</p>

                      <ul className="social-icon social-default justify-content-start">
                        {footer.socialLink.map((value, innerIndex) => (
                          <li key={innerIndex}>
                            <Link href={value.link}>
                              <i className={value.icon}></i>
                            </Link>
                          </li>
                        ))}
                      </ul>

                      <div className="contact-btn mt--30">
                        <Link
                          className="rbt-btn hover-icon-reverse btn-border-gradient radius-round"
                          href="/contact"
                        >
                          <div className="icon-reverse-wrapper">
                            <span className="btn-text">Contact With Us</span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right"></i>
                            </span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right"></i>
                            </span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <SingleFooter
                    classOne="col-lg-2 col-md-6 col-sm-6 col-12 mt--30"
                    title="Help Center"
                    footerType={footer.usefulLinks}
                  />
                  <SingleFooter
                    classOne="col-lg-2 col-md-6 col-sm-6 col-12"
                    title="Our Company"
                    footerType={footer.ourCompany}
                  />

                  <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                    <div className="footer-widget">
                      <h5 className="ft-title">Get Contact</h5>
                      <ul className="ft-link">
                        <li>
                          <span>Phone: </span>
                          <Link href="#">{footer.phone}</Link>
                        </li>
                        <li>
                          <span>E-mail:</span>{" "}
                          <Link href="mailto:hr@example.com">
                            {footer.mail}
                          </Link>
                        </li>
                      </ul>

                      <form 
                        className="newsletter-form mt--20" 
                        onSubmit={handleNewsletterSubmit}
                      >
                        <h6 className="w-600">Newsletter</h6>
                        <p className="description">{footer.descriptionTwo}</p>

                        <div className="form-group right-icon icon-email mb--20">
                          <input
                            id="email"
                            type="email"
                            placeholder="Enter Your Email Here"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={loading}
                          />
                        </div>

                        {message.text && (
                          <div className={`newsletter-message ${message.type} mb--15`}>
                            <small>{message.text}</small>
                          </div>
                        )}

                        <div className="form-group mb--0">
                          <button
                            className="rbt-btn rbt-switch-btn btn-gradient radius-round btn-sm"
                            type="submit"
                            disabled={loading}
                          >
                            <span data-text={loading ? "Subscribing..." : "Submit Now"}>
                              {loading ? "Subscribing..." : "Submit Now"}
                            </span>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <CopyRight />
      </footer>

      <style jsx>{`
        .newsletter-message {
          padding: 8px 12px;
          border-radius: 4px;
          font-size: 13px;
          animation: slideIn 0.3s ease-out;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-5px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .newsletter-message.success {
          background-color: rgba(40, 167, 69, 0.1);
          border: 1px solid rgba(40, 167, 69, 0.3);
          color: #28a745;
        }

        .newsletter-message.error {
          background-color: rgba(220, 53, 69, 0.1);
          border: 1px solid rgba(220, 53, 69, 0.3);
          color: #dc3545;
        }

        .newsletter-form input:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .newsletter-form button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
      `}</style>
    </>
  );
};

export default FooterOne;
